import { useCallback, useEffect, useState } from 'react';
import api from '../services/api';

export interface TurmaOption {
  id: number;
  nome: string;
  creche_id: number;
  faixa_etaria?: string;
  turno?: string;
}

export function useTurmas() {
  const [turmas, setTurmas] = useState<TurmaOption[]>([]);

  const carregarTurmas = useCallback(async () => {
    try {
      const { data } = await api.get<TurmaOption[]>('/turmas');
      setTurmas(data || []);
    } catch {
      setTurmas([]);
    }
  }, []);

  useEffect(() => {
    carregarTurmas();
  }, [carregarTurmas]);

  return { turmas, carregarTurmas };
}
